module.exports = __webpack_public_path__ + "static/media/astro.cba5e6f4.png";